import { createScreenText } from 'helpers/screenText';
const st = createScreenText('ticket_design_template');

// src/pages/TicketDesignTemplate/types.ts
// TypeScript type definitions cho Quản lý Mẫu Thiết kế Vé

// Khớp với TicketDesignTemplateStatuses enum bên backend (TicketService/Entities).
export const TICKET_DESIGN_TEMPLATE_STATUS = {
  Pending: 1,
  Approved: 2,
  Locked: 3,
} as const;

export type TicketDesignTemplateStatus = 1 | 2 | 3;

// Khớp với TicketDesignTemplateDto từ backend
export interface TicketDesignTemplate {
  id?: number;
  templateCode?: string;           // MV-001 … MV-999 (auto-gen, readonly)
  templateName?: string;
  designUnit?: 'Internal' | 'External';
  issuancePeriod?: string;         // K3-MM/YYYY
  issuancePeriodId?: number | null;
  status?: TicketDesignTemplateStatus;
  isDeleted?: boolean;
  statusName?: string | null;
  statusDisplayName?: string;      // "Chờ duyệt" | "Đã duyệt"
  approverId?: number | null;
  approverName?: string | null;
  approvedAt?: string | null;
  fileKey?: string | null;         // chỉ dùng nội bộ để request file-url
  fileName?: string | null;
  fileSize?: number | null;        // bytes
  fileType?: string | null;
  fileUrl?: string | null;         // Signed URL — short-lived, không cache
  layoutJson?: string | null;      // Vị trí/kích thước mã vé, số vé, QR, ngày mở thưởng — chỉ phục vụ xem trước
  uploadedBy?: number;
  uploadedByName?: string | null;
  createdAt?: string;
  createdBy?: number | null;
  lastModifiedAt?: string | null;
  lastModifiedBy?: number | null;
}

// DTO cho việc tạo mới template
export interface CreateTicketDesignTemplateDto {
  templateName: string;
  designUnit: 'Internal' | 'External';
  issuancePeriod: string;
  fileKey?: string;
  fileName?: string;
  fileSize?: number;
  fileType?: string;
}

// DTO cho việc cập nhật template
export interface UpdateTicketDesignTemplateDto extends CreateTicketDesignTemplateDto {
  id: number;
}

export interface UpdateTicketDesignTemplateFileDto {
  id: number;
  file: File;
}

// Filter parameters cho việc search — status giữ dạng string vì <select> HTML luôn trả string,
// quy đổi sang number khi build query params gửi API (xem index.tsx).
export interface TicketDesignTemplateFilters {
  searchTerm: string;
  status?: 'All' | '1' | '2' | '3';
  designUnit?: 'All' | 'Internal' | 'External';
  issuancePeriod?: string;
}

// Pagination info
export interface TicketDesignTemplatePagination {
  currentPage: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
}

// Modal states
export interface TicketDesignTemplateModalState {
  create: boolean;
  edit: boolean;
  delete: boolean;
  approve: boolean;
  preview: boolean;
}

// Lookup data cho dropdown
export interface DesignUnitOption {
  value: 'Internal' | 'External';
  label: string;
}

export const DESIGN_UNIT_OPTIONS: DesignUnitOption[] = [
  { value: 'Internal', label: st('phong_phat_hanh_label') },
  { value: 'External', label: st('thue_ngoai_label') },
];

export const STATUS_OPTIONS = [
  { value: 'All', label: st('tat_ca_option') },
  { value: '1', label: st('cho_duyet_label') },
  { value: '2', label: st('da_duyet_label') },
  { value: '3', label: st('da_khoa_text') },
];

// Status display labels — key là số (dạng string vì Record key) khớp TICKET_DESIGN_TEMPLATE_STATUS.
export const STATUS_LABELS: Record<string, string> = {
  1: st('cho_duyet_label'),
  2: st('da_duyet_label'),
  3: st('da_khoa_text'),
};

// DesignUnit display labels
export const DESIGN_UNIT_LABELS: Record<string, string> = {
  Internal: st('phong_phat_hanh_label'),
  External: st('thue_ngoai_label'),
};
